// Default argument for switch statements so TypeScript notifies if we fail to cover a case
const exhaustiveCheck = (arg: never) => arg

export default exhaustiveCheck
